<div class="row">
    <div class="col-sm-6">
        <h4>Lista de red de observatorios</h4>
    </div>
    <div class="col-sm-6 text-end">
        <a [routerLink]="'../add-info/' + idRed" class="btn-add" *ngIf="createText">
            <i class="fa fa-plus px-2"></i> Texto introductorio
        </a>
        <a routerLink="../add" class="btn-add" *ngIf="accessMP">
            <i class="fa fa-plus px-2"></i> Agregar nuevo
        </a>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Denominación</th>
                    <th scope="col">Estado</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let n of networks; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ n.name }}</td>
                    <td class="text-center">
                        <div class="label-active text-center" *ngIf="n.status">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!n.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/redes/edit', n.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <td class="text-center"><a class="a-icon" (click)="delRed(n.id)"><i
                                    class="fa fa-trash i-icon"></i></a>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div id="popup" class="popup">
    <span id="message">Se eliminó el registro</span>
</div>